var React = require('react');

function DownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"none","stroke":"#fff","strokeLinecap":"square","strokeMiterlimit":"50","strokeWidth":"2","d":"M15 1v18"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","stroke":"#fff","strokeMiterlimit":"50","strokeWidth":"2","d":"M9 15v0l6 6v0l6-6v0"})),React.createElement("g",{"key":2},React.createElement("path",{"fill":"none","stroke":"#fff","strokeMiterlimit":"50","strokeWidth":"2","d":"M29 15v14H1v0-14 0"}))])));
}

DownloadIcon.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = DownloadIcon;

DownloadIcon.default = DownloadIcon;
